import type { ApiClient } from '../../api/client';
import type { StaffingWorker as ApiStaffingWorker } from '../../api/types';
import type {
  LifecyclePort,
  LifecycleWorker,
} from '../../features/lifecycle/public';

function mapLifecycleWorker(worker: ApiStaffingWorker): LifecycleWorker {
  return {
    id: worker.id,
    name: worker.descriptor?.trim() || '이름 미등록',
    workerNumber: worker.workerId || '사번 미등록',
    workerType: worker.workerType?.descriptor || '유형 미등록',
    workerTypeId: worker.workerType?.id,
    detail: [worker.primaryJob?.jobProfile?.descriptor || worker.primaryJob?.businessTitle, worker.primaryJob?.supervisoryOrganization?.descriptor].filter(Boolean).join(' · '),
  };
}

export function createLifecycleHttpAdapter(client: ApiClient): LifecyclePort {
  return {
    async list() {
      return (await client.listChecklists()).data;
    },
    async listWorkers() {
      return (await client.listAllWorkers()).data.map(mapLifecycleWorker);
    },
    async listTemplates() {
      return (await client.listChecklistTemplates()).data;
    },
    create(workerId, templateId, targetOn) {
      return client.createChecklist(workerId, templateId, targetOn);
    },
    complete(checklistId, itemId) {
      return client.completeChecklistItem(checklistId, itemId);
    },
    createTemplate(input, idempotencyKey) {
      return client.createChecklistTemplate(input, idempotencyKey);
    },
    createTemplateVersion(templateId, expectedVersion, input, idempotencyKey) {
      return client.createChecklistTemplateVersion(templateId, expectedVersion, input, idempotencyKey);
    },
    setTemplateActive(templateId, active, expectedVersion) {
      return client.setChecklistTemplateActive(templateId, active, expectedVersion);
    },
  };
}
